<ng-select  [placeholder]="to.placeholder" [items]="source  | async"
           class="filter-dropdown" [multiple]="true"  [selectableGroup]="false"
           [closeOnSelect]="false" bindLabel="displayText" bindValue="id" [formControl]="formControl">
  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    <div class="ng-value" *ngFor="let item of items | slice:0:1">
      <span class="ng-value-label">
        {{item.displayText}}
      </span>
      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
    </div>
    <div class="ng-value" *ngIf="items.length > 1">
      <span class="ng-value-label">+{{items.length - 1}}</span>
    </div>
  </ng-template>
</ng-select>
